import {TOKENS_TO_STATUS} from '@/utils/constants/tokens';

export default {
  getTokenTypes() {
    return Object.keys(TOKENS_TO_STATUS);
  },
  getTokenTypeByStatus(status) {
    return Object.keys(TOKENS_TO_STATUS).find(key => TOKENS_TO_STATUS[key] === status);
  },
  getStatusByTokenType(type) {
    return TOKENS_TO_STATUS[type];
  }
};
